<template>
  <div class="remarkInfo">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="交付备注" name="0"></el-tab-pane>
      <el-tab-pane label="随访备注" name="1"></el-tab-pane>
      <el-tab-pane label="我的备注" name="2"></el-tab-pane>
      <el-tab-pane label="患者标签" name="3"></el-tab-pane>
    </el-tabs>
    <div class="remark_container" v-if="activeName == '0'">
      <div class="remark_question" v-loading="questionLoading" v-if="totalPageDelivery > 0">
        <div>{{ currentPageDelivery }}. {{ deliveryRemark.questionTitle }}</div>
        <div style="color:#b3b3b3;font-size:14px;">{{ deliveryRemark.questionDescription }}</div>
        <!-- 多种情况 -->
        <!-- 单选、问答、日期、地理位置 -->
        <div v-if="deliveryRemark.questionType == '1'">
          <el-radio-group v-model="answerInfo.answer">
            <el-radio v-for="item in deliveryRemark.optionInfoArray" :key="item.serialNumber"
              :label="item.title"></el-radio>
          </el-radio-group>
        </div>
        <div v-if="deliveryRemark.questionType == '2'">
          <div class="input-width" v-if="deliveryRemark.dataVerificationObj.validationType == '1'">
            <el-input type="textarea" v-model="answerInfo.answer" placeholder="请输入内容"></el-input>
          </div>
          <div v-if="deliveryRemark.dataVerificationObj.validationType == '2'">
            <el-input-number v-model="answerInfo.answer" label="数值" :min="0" size="small"></el-input-number>
            <span>{{ deliveryRemark.dataVerificationObj.demand.unit }}</span>
          </div>
          <div class="input-width" v-if="deliveryRemark.dataVerificationObj.validationType == '3'">
            <el-input v-model="answerInfo.answer" placeholder="手机号"></el-input>
          </div>
          <div class="input-width" v-if="deliveryRemark.dataVerificationObj.validationType == '4'">
            <el-input v-model="answerInfo.answer" placeholder="固定电话"></el-input>
          </div>
          <div v-if="!deliveryRemark.dataVerificationObj.validationType">
            <el-input type="textarea" v-model="answerInfo.answer" placeholder="请输入内容"></el-input>
          </div>
        </div>
        <div v-if="deliveryRemark.questionType == '3'">
          <el-date-picker v-if="deliveryRemark.selectType == '1'" v-model="answerInfo.date" type="datetime"
            value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" placeholder="年月日  时分">
          </el-date-picker>

          <el-date-picker v-if="deliveryRemark.selectType == '2'" v-model="answerInfo.date" type="date"
            value-format="yyyy-MM-dd" placeholder="年月日">
          </el-date-picker>

          <el-date-picker v-if="deliveryRemark.selectType == '3'" v-model="answerInfo.date" type="month"
            value-format="yyyy-MM" placeholder="年月">
          </el-date-picker>
          <el-time-picker v-if="deliveryRemark.selectType == '4'" placeholder="时分" v-model="answerInfo.date"
            value-format='HH:mm' format='HH:mm' :picker-options="{
              selectableRange: '00:00:00 - 23:59:59'
            }">
          </el-time-picker>
        </div>
        <div v-if="deliveryRemark.questionType == '4'">
          <!-- 省市 -->
          <div v-if="deliveryRemark.selectType == '5'">
            <el-cascader size="large" :options="options.opetions1" placeholder="省/市"
              v-model="answerInfo.selectedOptions" @change="handleChange">
            </el-cascader>
          </div>
          <!-- 省市区 街道 详细地址 -->
          <div v-else>
            <el-cascader size="large" :options="options.opetions2" placeholder="省/市/区"
              v-model="answerInfo.selectedOptions" @change="handleChange">
            </el-cascader>
            <span class="input-width">
              <el-input v-if="deliveryRemark.selectType == '7' || deliveryRemark.selectType == '8'"
                v-model="answerInfo.street" placeholder="街道名称"></el-input>
            </span>
            <el-input v-if="deliveryRemark.selectType == '8'" v-model="answerInfo.other" placeholder="详细地址"></el-input>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <el-pagination background small layout="total, prev, pager, next, jumper" :page-count="totalPageDelivery"
          :current-page="currentPageDelivery" @current-change="currentChangeDelivery"></el-pagination>
        <span v-if="totalPageDelivery > 0">
          <el-button size="mini" type="primary" plain @click="clearDeliveryAnswer">清除</el-button>
          <el-button size="mini" type="primary" @click="saveDeliveryAnswer">保存</el-button>
        </span>
      </div>
    </div>
    <div class="remark_container" v-if="activeName == '1' || activeName == '2'">
      <div class="remark_input" style="margin-bottom: 10px;">
        <el-select @change="changeHandler" size="mini" v-model="selectInput" placeholder="请选择备注" clearable>
          <el-option v-for="(item,index) in selectInputList" :key="index" :label="item.label" :value="item.label"></el-option>
        </el-select>
      </div>
      <div class="remark_input">
        <el-input v-model="remarkContent" placeholder="请输入备注信息" size="mini" maxlength="500" show-word-limit
          style="margin-right:10px;">
        </el-input>
        <el-button type="primary" size="mini" plain @click="clearRemark">清除</el-button>
        <el-button type="primary" size="mini" @click="addTags">确认</el-button>
      </div>
      <div class="remark_table" v-loading="tableLoading">
        <div class="remark-table">
          <div class="remark-list-item" v-for="(item, index) in remarkTableList" :key="item.id">
            <i class="remark-list-item-left">
              <span>
                {{ index + 1 }}
              </span>
            </i>
            <div class="remark-list-item-right">
              <div v-if="!item.isEdit" class="remark-list-item-right-top">{{ item.remark }}</div>
              <el-input v-if="item.isEdit" class="remark_input_inner" v-model="item.remarkInput" placeholder="请输入备注信息"
                size="mini" type="textarea" maxlength="500" show-word-limit
                style="margin-right:10px;width: 98%;"></el-input>
              <div class="remark-list-item-bottom">
                <div class="bottom-title">
                  {{ item.updateTime }}
                </div>
                <div v-if="!item.isEdit" class="icon-list">
                  <i @click="editRemark(item)" class="el-icon-edit"></i>
                  <i @click="deleteTagsHandler(item)" class="el-icon-delete-solid"></i>
                </div>
                <div style="margin-top: 10px;" v-if="item.isEdit">
                  <el-button @click="cancelUpdateRemark(item)" size="mini" type="">取消</el-button>
                  <el-button @click="updateFollowupRemark(item)" size="mini" type="primary">保存</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  患者标签 -->
    <div class="remark_container" v-if="activeName == '3'">
      <div style="height: 175px; overflow: auto;">
        <el-checkbox-group v-model="currentPatientTags" size="small" class="label-group">
          <el-checkbox v-for="item in taskTagList" :label="item.tagId" :key="item.tagId"
            border>{{ item.tagName }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div style="text-align: right;padding: 0 10px;">
        <el-button type="primary" size="mini" @click="updatePatientTags">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapGetters } from "vuex";
import { regionData, provinceAndCityData, codeToText } from 'element-china-area-data'

export default {
  name: 'remarkInfo',
  data() {
    return {
      selectInput: "",
      selectInputList: [{
        label: '请核对电话',
      },{
        label: '请优先联系',
      },{
        label: '随访请注意',
      },{
        label: '随访请参考',
      },{
        label: '【院方已复核】',
      },{
        label: '【患者行动不便，无法体检】',
      },{
        label: '【患者死亡】',
      },{
        label: '【语言/方言沟通障碍】',
      },{
        label: '【患者听力障碍】',
      },{
        label: '【患者肢体无力，无法拿电话】',
      },{
        label: '【患者否认入组/否认做过行走和认知测试】',
      },{
        label: '【患者配合差，拒随】',
      },{
        label: '【患者无微信/不会使用微信，发送短信无效】',
      },{
        label: '【数据备注】',
      },],
      activeName: "0",
      remarkTableList: [],
      deliveryRemark: {},
      remarkContent: "",
      totalPage: 1,
      currentPage: 1,
      tableLoading: false,
      returnPatientData: this.patientData,
      totalPageDelivery: 1,
      currentPageDelivery: 1,
      questionLoading: false,
      answerInfo: {
        answer: "",
        date: "",
        selectedOptions: [], //地理位置题
        street: "",
        other: ""
      },
      // 地理位置
      options: {
        opetions1: provinceAndCityData,
        opetions2: regionData
      },
      taskTagList: [],
      currentPatientTags: [], //患者标签
    }
  },
  props: ["taskId", "patientData", "patientTags"],
  computed: {
    ...mapGetters(["username", "userid",]),
  },
  watch: {
    'patientData': {
      handler(val, oldVal) {
        this.returnPatientData = val
      },
      immediate: true
    },
    'patientTags': {
      handler(val, oldVal) {
        this.currentPatientTags = val.map(tag => tag.tagId)
      },
      immediate: true
    },
  },
  components: {},
  mounted() {
    let vm = this;
    vm.onLoad();
  },
  methods: {
    onLoad() {
      console.log('returnPatientData-----------------------', this.returnPatientData);
      this.activeName = '0'
      this.getTags()
      this.getTaskTags()  //患者标签
    },
    clearDeliveryAnswer() {
      this.answerInfo = {
        answer: "",
        date: "",
        selectedOptions: [], //地理位置题
        street: "",
        other: ""
      }
    },
    handleClick(tab, event) {
      this.activeName = tab.name
      this.totalPage = 1
      this.currentPage = 1
      this.clearDeliveryAnswer()
      this.getTags()
      this.$forceUpdate()
    },
    getTags() {
      this.tableLoading = true
      this.clearDeliveryAnswer()
      if (this.activeName == '1' || this.activeName == '2') {
        this.$store.dispatch('requestHandler',
          {
            fn: 'RestRemarksCallcenterControllerGetTags',
            params: {
              seatId: this.activeName == '2' ? this.userid : null,
              followUpTaskId: this.taskId,
              followUpPatientId: this.returnPatientData.followupPatientId,
              remarkType: this.activeName * 1,
            }
          }
        ).then(res => {
          this.tableLoading = false
          if (res.status == 0) {
            this.remarkTableList = res.retValue.map(item => {
              item.remarkInput = item.remark
              item.isEdit = false
              return item
            })
            this.totalPage = res.totalPage
            this.currentPage = res.page
          }
        })
      } else if (this.activeName == '0') {
        this.questionLoading = true
        this.$store.dispatch('requestHandler',
          {
            fn: 'RestRemarksCallcenterControllerGetDeliveryRemark',
            params: {
              followUpTaskId: this.taskId,
              followUpPatientId: this.returnPatientData.followupPatientId,
              seatId: this.userid,
              pageIndex: this.currentPageDelivery,
              pageSize: 1,
            }
          }
        ).then(res => {
          this.questionLoading = false
          if (res.status == 0 && res.retValue.length > 0) {
            let deliveryRemarkList = res.retValue.map(item => {
              item.optionInfoArray = item.optionInfo ? JSON.parse(item.optionInfo) : []
              item.dataVerificationObj = item.dataVerification ? JSON.parse(item.dataVerification) : {}
              if (item.followupDeliveryRemark.answerInfo) {
                this.answerInfo = JSON.parse(item.followupDeliveryRemark.answerInfo)
              } else {
                this.answerInfo = {
                  answer: "",
                  date: "",
                  selectedOptions: [], //地理位置题
                  street: "",
                  other: ""
                }
              }
              return item
            })
            this.deliveryRemark = deliveryRemarkList[0]
            this.totalPageDelivery = res.totalPage
            this.currentPageDelivery = res.page
            console.log('this.deliveryRemark', this.deliveryRemark);
          } else {
            this.totalPageDelivery = 0
          }

        })
      }

      this.$forceUpdate()
    },
    editRemark(item) {
      this.$set(item, 'isEdit', true)
    },
    changeHandler(val) {
      this.remarkContent = val
      this.addTags()
      this.selectInput = ''
    },
    deleteTagsHandler(item) {
      this.$confirm(this.activeName === '1' ? '是否确认删除随访标签?' : '是否确认删除我的备注?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteTags({
          id: item.id
        }).then(res => {
          this.$message.success('删除成功')
          this.getTags()
        })
      }).catch()
    },
    //RestRemarksManagerControllerDeleteTags删除随访备注
    async deleteTags(p) {
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestRemarksCallcenterControllerDeleteTags',
        params: {
          id: p.id,
          userId: this.userid,
          userName: this.username,
        }
      })
      return result
    },
    cancelUpdateRemark(item) {
      item.remarkInput = item.remark
      item.isEdit = false
    },
    updateFollowupRemark(item) {
      if (!item.remarkInput) {
        this.$message.error('备注信息不能为空')
        return
      }
      this.$store.dispatch('requestHandler',
        {
          fn: 'RestRemarksCallcenterControllerEditTags',
          params: {
            id: item.id,
            seatId: this.userid,
            seatName: this.username,
            followUpTaskId: this.taskId,
            followUpPatientId: this.returnPatientData.followupPatientId,
            followUpPatientName: this.returnPatientData.userName,
            remarkType: this.activeName * 1,
            tags: item.remarkInput
          }
        }
      ).then(res => {
        if (res.status == 0) {
          this.getTags()
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
      })
    },
    addTags() {
      if (!this.remarkContent) {
        this.$message.warning("请填写备注信息")
        return
      }
      this.$store.dispatch('requestHandler',
        {
          fn: 'RestRemarksCallcenterControllerEditTags',
          params: {
            seatId: this.userid,
            seatName: this.username,
            followUpTaskId: this.taskId,
            followUpPatientId: this.returnPatientData.followupPatientId,
            followUpPatientName: this.returnPatientData.userName,
            remarkType: this.activeName * 1,
            tags: this.remarkContent
          }
        }
      ).then(res => {
        if (res.status == 0) {
          this.remarkContent = ""
          this.getTags()
        }
      })
    },
    clearRemark() {
      this.remarkContent = ""
    },
    currentChange(currentPage) {
      this.currentPage = currentPage;
      this.getTags()
    },
    currentChangeDelivery(currentPage) {
      this.clearDeliveryAnswer()
      console.log('currentPage', currentPage);
      this.currentPageDelivery = currentPage;
      this.getTags()
    },
    saveDeliveryAnswer() {
      if (this.deliveryRemark.questionType == '2') {
        let judge = this.judgeInput()
        if (!judge) {
          if (this.deliveryRemark.dataVerificationObj.validationType == '4') {
            this.$message.warning('格式不正确，正确格式参考"021-xxxxxxxx"')
          } else {
            this.$message.warning(this.deliveryRemark.dataVerificationStr)
          }
          return
        }
      }
      if (this.deliveryRemark.questionType == '4') {//地理位置
        this.answerInfo.answer += this.answerInfo.street + this.answerInfo.other
      }
      if (this.deliveryRemark.questionType == '3') {//日期时间
        this.answerInfo.answer = this.answerInfo.date

      }
      this.$store.dispatch('requestHandler',
        {
          fn: 'RestRemarksCallcenterControllerEditDeliveryRemark',
          params: {
            seatId: this.userid,
            seatName: this.username,
            followUpTaskId: this.taskId,
            followUpPatientId: this.returnPatientData.followupPatientId,
            followUpPatientName: this.returnPatientData.userName,
            deliveryQuestionId: this.deliveryRemark.id,
            answerInfo: JSON.stringify(this.answerInfo),
          }
        }
      ).then(res => {
        if (res.status == 0) {
          this.$message.success("保存成功")
        } else {
          this.$message.errpr("保存失败")
        }
      })
    },
    judgeInput() {
      let type = this.deliveryRemark.dataVerificationObj.validationType
      let _demand = this.deliveryRemark.dataVerificationObj.demand
      let result = true;
      //字符1 数字2 手机号3  固定电话4
      switch (type) {
        case '1':
          if (this.answerInfo.answer && _demand.number) {
            result = this.inputNumberVerify()
          }
          break;
        case '2':
          if (_demand.number || _demand.min || _demand.max) {
            result = this.numberRangeVerify()
          }
          break;
        case '3':
          result = this.phoneVerify(1)
          break;
        case '4':
          result = this.phoneVerify(2)
          break;
        default:
          break;
      }
      return result
    },
    inputNumberVerify() {
      let input_result = true
      let _demand = this.deliveryRemark.dataVerificationObj.demand
      switch (_demand.radius) {
        case '8'://不超过
          input_result = this.answerInfo.answer.length < _demand.number || this.answerInfo.answer.length == _demand.number
          break;
        case '9'://不少于
          input_result = this.answerInfo.answer.length > _demand.number || this.answerInfo.answer.length == _demand.number
          break;
        case '10'://固定
          input_result = this.answerInfo.answer.length == _demand.number
          break;

        default:
          break;
      }
      return input_result
    },
    numberRangeVerify() { //bool : 整数、小数判断
      let _demand = this.deliveryRemark.dataVerificationObj.demand
      if (_demand.format) {
        let reg;
        if (_demand.format == '2') { //小数
          reg = /^(0|[1-9]\d*)\.\d+$/;
        } else if (_demand.format == '1') { //整数
          reg = /^-?\d+$/;
        }
        if (!reg.test(this.answerInfo.answer)) { //不符合小数/整数判断
          return
        }
      }
      let number_result = true
      switch (_demand.radius) {
        case '1':
          number_result = this.answerInfo.answer > _demand.min && this.answerInfo.answer < _demand.max
          break;
        case '2':
          number_result = this.answerInfo.answer < _demand.min || this.answerInfo.answer > _demand.max
          break;
        case '3':
          number_result = this.answerInfo.answer != _demand.number
          break;
        case '4':

          number_result = this.answerInfo.answer > _demand.number
          break;
        case '5':
          number_result = this.answerInfo.answer < _demand.number
          break;
        case '6':
          number_result = this.answerInfo.answer > _demand.number || this.answerInfo.answer == _demand.number
          break;
        case '7':
          number_result = this.answerInfo.answer < _demand.number || this.answerInfo.answer == _demand.number
          break;
        default:
          break;
      }
      return number_result
    },
    phoneVerify(type) {
      let reg;
      if (type == 1) {
        reg = /^1[3-9]\d{9}$/;
      } else {
        reg = /^\d{3}-\d{8}$|^\d{4}-\d{7}$/;
      }
      return reg.test(this.answerInfo.answer)
    },
    handleChange(value) {
      let geography = ""
      if (value) {
        value.forEach(item => {
          geography += codeToText[item];
        })
      }
      this.answerInfo.answer = geography
    },
    // ===================患者标签====================
    getTaskTags() {
      this.taskTagList = []
      this.$store.dispatch('requestHandler',
        {
          fn: 'RestNewFollowupCallCenterServiceQueryTaskTag',
          params: {
            taskId: this.taskId
          }
        }
      ).then(res => {
        if (res.status == 0) {
          this.taskTagList = res.retValue
        }
      })
    },
    updatePatientTags() {
      let addTagArr = [];
      let delTagArr = [];
      // 获取新增的数据
      this.currentPatientTags.forEach((item) => {
        if (this.patientTags.findIndex((el) => el.tagId === item) === -1) {
          addTagArr.push(item);
        }
      });
      // 获取删除的数据
      this.patientTags.forEach((item) => {
        if (this.currentPatientTags.findIndex((el) => el === item.tagId) === -1) {
          delTagArr.push(item.tagId);
        }
      });
      const promises = [];
      if (addTagArr.length > 0) {
        promises.push(this.addTaskTag(addTagArr))
      }
      if (delTagArr.length > 0) {
        promises.push(this.deleteTaskTag(delTagArr))
      }
      if (promises.length > 0) {
        Promise.all(promises)
          .then(() => {
            this.$message.success("保存成功")
            this.$emit("refreshTags")
          })
          .catch();
      }
    },
    addTaskTag(addTagArr) {
      return new Promise((resolve, reject) => {
        if (addTagArr.length === 0) {
          resolve();
        } else {
          this.$store.dispatch('requestHandler',
            {
              fn: 'RestNewFollowupCallCenterServiceAddPatientTag',
              params: {
                tagIds: addTagArr,
                followupPatientId: this.returnPatientData.followupPatientId,
                followupPatientName: this.returnPatientData.userName,
                patientId: this.returnPatientData.patientId,
                taskId: this.taskId,
                admitNo: this.returnPatientData.admitNo,
                seatId: this.userid,
              }
            }
          ).then(res => {
            if (res.status == 0) {
              resolve();
            } else {
              this.$message.error("新增标签失败：" + res.desc)
            }
          })
        }
      })

    },
    deleteTaskTag(delTagArr) {
      return new Promise((resolve, reject) => {
        if (delTagArr.length === 0) {
          resolve();
        } else {
          this.$store.dispatch('requestHandler',
            {
              fn: 'RestNewFollowupCallCenterServiceDeletePatientTag',
              params: {
                tagIds: delTagArr,
                followupPatientId: this.returnPatientData.followupPatientId,
                followupPatientName: this.returnPatientData.userName,
                patientId: this.returnPatientData.patientId,
                taskId: this.taskId,
                admitNo: this.returnPatientData.admitNo,
                seatId: this.userid,
              }
            }
          ).then(res => {
            if (res.status == 0) {
              resolve();
            } else {
              reject(new Error("删除标签失败：" + res.desc));
            }
          })
        }
      })
    },

  }
}
</script>

<style scoped lang="scss">
.remarkInfo {
  .remark_container {
    .remark_input {
      margin: 0 10px;
      display: flex;
    }

    .remark_table {
      // border:1px solid #ccc;
      height: 155px;
      overflow: auto;
      margin: 10px 12px;
      margin-bottom: 5px;
      line-height: 18px;
      font-size: 15px;
    }

    .remark_list_item {
      display: grid;
      grid-template-columns: auto 160px;
      grid-gap: 15px;
      margin-bottom: 12px;
    }

    .remark_question {
      // border:1px solid #ccc;
      height: 160px;
      overflow: auto;
      margin: 10px 12px;
      margin-bottom: 5px;
      line-height: 18px;
      font-size: 15px;
    }
  }

  .pagination-bottom {
    display: flex;
    justify-content: space-between;
  }

  .label-group {
    padding: 10px;

    .el-button+.el-button,
    .el-checkbox.is-bordered+.el-checkbox.is-bordered {
      margin-left: 0;
    }

    .el-button,
    .el-checkbox.is-bordered {
      margin: 0 20px 8px 0 !important;
      border: 1px dashed #DCDFE6;
    }

    .el-checkbox.is-bordered.is-checked {
      border: 1px solid #c8e3ff;
      color: #44a0ff;
      background: #ecf5ff;
    }
  }
}

.remark-table {
  .remark-list-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #ccc;
    padding: 10px 0;

    &:last-child {
      border: none;
    }

    .remark-list-item-left {
      flex: .12;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        color: #000;
        font-size: 12px;
        text-align: center;
        border: 1px solid #000;
        border-radius: 50px;
        width: 20px;
        height: 20px;
        line-height: 20px;
      }
    }

    .remark-list-item-right {
      flex: .88;

      .remark-list-item-right-top {
        word-wrap: break-word;
        width: 98%;
        margin-bottom: 15px;
      }
    }

    .remark-list-item-bottom {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin-right: 12px;

      .bottom-title {
        font-size: 12px;
        line-height: 21px;
        color: #464040;
      }

      .icon-list {
        color: #248cfa;

        >i {
          cursor: pointer;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
div {
  word-break: break-word;
  word-wrap: normal;
}

.remarkInfo {
  .el-tabs__header {
    padding: 0 10px;
    margin-bottom: 10px;
  }

  .el-radio-group .el-radio {
    display: block;
    margin: 7px;
  }

  .remark_question {

    .el-input {
      margin-bottom: 10px;
    }
  }

  .remark_input {
    .el-input__inner {
      padding-right: 55px;
    }
  }

  .remark_question {
    .input-width .el-input {
      width: 300px;
    }
  }

  // 患者标签
  .label-group {
    padding: 10px;

    .el-button+.el-button,
    .el-checkbox.is-bordered+.el-checkbox.is-bordered {
      margin-left: 0;
    }

    .el-button,
    .el-checkbox.is-bordered {
      margin: 0 20px 8px 0;
      border: 1px dashed #DCDFE6;
    }

    .el-checkbox.is-bordered.is-checked {
      border: 1px solid #c8e3ff;
      color: #44a0ff;
      background: #ecf5ff;
    }
  }

  .label-group {
    .el-checkbox .el-checkbox__input {
      display: none;
    }

    .el-checkbox .el-checkbox__label {
      padding-left: 5px;
    }

    // #ecf5ff
  }
}
</style>
